<template lang="pug">
.coupons-item-container(
    v-if="type&&info",
    @click="handlerClick(info)"
    :class="[\
      'coupons-item-' + type, \
      statusClass, \
      {loading}, \
    ]"
)
  template(v-if="!loading")
    .corner.flex-mid(v-if="info.corner")
      span {{info.corner}}
    .left
      .price
        span.current(:style="priceStyle") {{info.currentPrice}}
        span.unit 元
      .detail(v-if="type !== 1") {{info.title}}
      .time(v-if="type !== 1") {{info.time}}
    .mid.flex-mid(v-if="type === 1")
      .title {{info.title}}
      .subtitle {{info.subtitle}}
      .time(v-if="info.status===status.use && info.time") {{info.time}}
    .right.flex-mid
        .btn(:class="{use: info.status === status.use}") {{ info.btnName }}
</template>

<script>
import { COUPON_STATUS } from '../consts';

export default {
  props: {
    info: {
      required: true,
      type: Object,
    },
    type: {
      required: true,
      type: Number,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: { ...COUPON_STATUS },
    };
  },
  computed: {
    statusClass() {
      if (this.info.status === this.status.use) {
        return 'status-2';
      }
      if (this.info.status === this.status.achieve) {
        return 'disabled';
      }
      if (this.info.status === this.status.expired) {
        return 'disabled';
      }
      if (this.info.status === this.status.wait) {
        return 'status-2';
      }
      if (this.info.status === this.status.fail) {
        return 'disabled';
      }
      return '';
    },
    priceStyle() {
      const { currentPrice } = this.info;

      if (this.type === 1) {
        return {};
      }
      const fs = `${(`${currentPrice}`).length > 1 ? '0.26' : '0.28'}rem`;
      return {
        fontSize: fs,
        lineHeight: fs,
      };
    },
  },
  methods: {
    handlerClick(item) {
      if (item.status === this.status.use) {
        this.$emit('use');
      } else if (item.status === this.status.receive) {
        this.$emit('receive');
      } else if (item.status === this.status.wait) {
        this.$emit('wait');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.fontStyle(@fw: bold, @co: #8f5c33, @lh: 0.12rem, @fs: 0.14rem) {
  font-weight: @fw;
  color: @co;
  line-height: @lh;
  font-size: @fs;
}

.ellipsis(@mw: 100%) {
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: keep-all;
  max-width: @mw;
}

.coupons-item-container {
  display: flex;
  position: relative;

  &.loading {
    background: #f0f3f5 !important;
    box-shadow: 0 0.01rem 0.02rem 0 rgba(0, 0, 0, 0.06);
    border-radius: 0.08rem;
    border: none;
  }

  .left {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .price {
      margin-bottom: 0.04rem;
      display: flex;
      align-items: flex-end;

      .current {
        position: relative;
        top: 0.01rem;
        .fontStyle(500, #5d3a26, 0.26rem, 0.26rem);
      }

      .unit {
        margin-left: 0.02rem;
        .fontStyle(bold, #5d3a26, 0.17rem, 0.12rem);
      }
    }

    .detail {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .time,
    .detail {
      .fontStyle(400, #5d3a26, 1, 0.1rem);
    }

    .time {
      margin-top: 0.03rem;
      font-size: 0.09rem;
      line-height: 0.12rem;
      .ellipsis(90%);
    }
  }

  .right {
    .btn {
      .fontStyle(bold);
    }

    .use {
      color: #d5261b;
    }
  }

  .corner {
    position: absolute;
    top: 0;
    left: 0;
    height: 0.16rem;
    background: #ffeec8;
    border-radius: 0.08rem 0 0.08rem 0;
    padding: 0.02rem 0.05rem;

    > span {
      .fontStyle(bold, #6e461b, 0.1rem, 0.1rem);
    }
  }

  &.coupons-item-1 {
    width: 100%;
    padding: 0.25rem 0 0.25rem 0;
    height: 0.82rem;
    background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/24b88e82-00e7-4073-b398-ac9fd10a875c.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;

    .left {
      max-width: 0.74rem;

      .price {
        .current {
          line-height: 0.28rem;
          font-size: 0.3rem;
        }

        .unit {
          margin-left: 0.03rem;
          line-height: 0.18rem;
          font-size: 0.13rem;
        }
      }
    }

    .mid {
      flex-direction: column;
      align-items: flex-start;
      flex: 1;
      .fontStyle(bold, #5d3a26, 0.14rem, 0.14rem);

      .title {
        margin-bottom: 0.08rem;
      }

      .subtitle,
      .time {
        font-weight: 400;
        font-size: 0.12rem;
        line-height: 0.12rem;
      }

      .time {
        margin-top: 0.04rem;
        .ellipsis();
      }
    }

    .right {
      width: 0.87rem;
    }
  }

  &.coupons-item-2 {
    width: 100%;
    padding: 0.22rem 0 0.22rem 0;
    background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/168d4e39-36c3-4043-8669-c7b9bc394c8c.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;

    .left {
      padding: 0 0.05rem;
      max-width: 0.97rem;
    }

    .right {
      width: 0.63rem;
    }
  }

  &.coupons-item-3 {
    flex-direction: column;
    width: 100%;
    height: 1.09rem;
    max-height: 1.09rem;
    min-height: 1.09rem;
    background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/c66c7775-2b74-4085-9982-d040cde6c607.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;

    .left {
      padding: 0 0.05rem;
      padding-top: 0.05rem;
    }

    .right {
      height: 0.3rem;
    }
  }

  &.disabled {
    &.coupons-item-1 {
      background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/258509fd-8c9f-40b8-8e1c-50c0fdd143df.png?x-oss-process=image/quality,q_80);
    }

    &.coupons-item-2 {
      background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/3704b561-330f-4b3c-ba2d-e1b16179b18e.png?x-oss-process=image/quality,q_80);
    }

    &.coupons-item-3 {
      background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/3eb3ce86-0102-4af2-bb75-1080b28f17ba.png?x-oss-process=image/quality,q_80);
    }

    &.coupons-item-1,
    &.coupons-item-2,
    &.coupons-item-3 {
      .left {
        .current,
        .unit {
          color: #879099 !important;
        }
      }

      .mid,
      .btn,
      .detail,
      .time {
        color: #879099 !important;
      }
    }
  }

  &.status-2 {
    &.coupons-item-1 {
      padding: 0.16rem 0 0.16rem 0;
    }
  }
}
</style>
